import React from 'react'

const IcTruck = ({ className, size = 20 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.3335 13.3333V2.5H0.833496V13.3333H13.3335ZM13.3335 13.3333H19.1668V9.16667L16.6668 6.66667H13.3335V13.3333ZM6.66683 15.4167C6.66683 16.5673 5.73409 17.5 4.5835 17.5C3.4329 17.5 2.50016 16.5673 2.50016 15.4167C2.50016 14.2661 3.4329 13.3333 4.5835 13.3333C5.73409 13.3333 6.66683 14.2661 6.66683 15.4167ZM17.5002 15.4167C17.5002 16.5673 16.5674 17.5 15.4168 17.5C14.2662 17.5 13.3335 16.5673 13.3335 15.4167C13.3335 14.2661 14.2662 13.3333 15.4168 13.3333C16.5674 13.3333 17.5002 14.2661 17.5002 15.4167Z" stroke="#667085" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export default IcTruck
